import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { Router, ActivatedRoute } from '@angular/router';
import { InvoiceItemComponent } from '../../mnt-invoices/invoice-item/invoice-item.component';
import { ProductDetailComponent } from '../../mnt-invoices/product-detail/product-detail.component';
import { ShippingInfoComponent } from '../../mnt-invoices/shipping-info/shipping-info.component';
import { CheckOutComponent } from '../../mnt-invoices/check-out/check-out.component';
import { MatDialog } from "@angular/material";
import { Title } from '@angular/platform-browser';
import { AllMockupRevisionComponent } from '../all-mockup-revision/all-mockup-revision.component';
import { connectableObservableDescriptor } from 'rxjs/observable/ConnectableObservable';
import { SquareupResponseComponent } from '../../mnt-invoices/squareup-response/squareup-response.component'
import { SettingService } from '../../_services/setting.service';
@Component({
  selector: 'app-public-order',
  templateUrl: './public-order.component.html',
  styleUrls: ['./public-order.component.css']
})
export class PublicOrderComponent implements OnInit {

  public orderType = 'Quote';
  public loading = false;
  public pageLoading = false;
  private tempProjectData: any;
  public projects: any = {};
  public currentMessage = {};
  public isOpenComments = {};
  public replydisabled = true;
  public turnAroundName: string;
  public shippingMethodName: string;
  public balanceAmount: number;
  turnAroundTimes: Array<any> = [];
  shipping: Array<any> = [];
  address: Array<any> = [];
  public is_payment_term = 'No';
  private isShowCheckout = false;
  public mockupButtonclass = "btn-large btn-blue";
  public mockupButtonText = "Click Here to Review and Approve Mockups";
  public taskList: Array<any> = [];
  public clientData: any;
  public isturnOffPerPriceView = false;
  public isTurnOffImpressionCost = false;
  public isShippingOption = true;
  public isLocalPickupOption = true;
  public isConnectQBO:boolean = false;
  public cardProcessingFees: any = [];
  public scheduledDate: string = '';
  public paymentHistory: any = [];
  public refundHistory:any = [];
  public isTaxExempt: string = '0';
  public taxRate = 0;

  constructor(private CommonService: CommonService,
    private activateroute: ActivatedRoute,
    private dialog: MatDialog,
    private titleService: Title,
    private router: Router,
    private SettingService: SettingService
  ) { }

  ngOnInit() {
    if (this.activateroute.snapshot.params["token"]) {
      let siteDetail = JSON.parse(localStorage.getItem('siteData'));
      if (siteDetail) {
        this.titleService.setTitle(siteDetail.site_title);
        $("#appPrintLifeFavicon").attr("href", siteDetail.site_favicon);

      }
      let userDetails = JSON.parse(localStorage.getItem('userDetails'));
      if (userDetails) {
        this.titleService.setTitle(userDetails.site_data.site_title);
        $("#appPrintLifeFavicon").attr("href", userDetails.site_data.site_favicon);

      }

      this.getOrderList();
      if (localStorage.getItem("paymentBySquare") && localStorage.getItem("processingOrder") && localStorage.getItem("processingData")) {
        this.activateroute.queryParams.subscribe(params => {
          if (params.order == localStorage.getItem("processingOrder") && localStorage.getItem("paymentBySquare") == "processing") {
            var processingData = JSON.parse(localStorage.getItem("processingData"));
            this.processPayments(processingData, params.transactionId);
          }
        });
      }
    }
  }

  processPayments = function (data, transactionId) {
    const paymentData = new FormData();
    // paymentData.append('id', localStorage.getItem("userID"));
    paymentData.append('id', localStorage.getItem("shopID"));
    paymentData.append('order_id', data.order_id);
    paymentData.append('transaction_id', transactionId);
    paymentData.append('payment_type', "Squareup");
    paymentData.append('amount', localStorage.getItem('squarePayableAmount'));

    this.loading = true;
    this.CommonService.apiService(
      "POST",
      "payment",
      paymentData
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          localStorage.removeItem("paymentBySquare");
          localStorage.removeItem("processingOrder");
          localStorage.removeItem("processingData");
          localStorage.removeItem("squarePayableAmount");
          localStorage.setItem('isSquareupResponse', 'true');
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            // When the pathname does start with '/builder/invoice/', then add the pathname same as invoice builder
            if (window.location.pathname.startsWith('/builder/invoice/')) {
              this.router.navigate(["/builder/invoice/" + this.activateroute.snapshot.params["token"]]);
            }
            else {
              this.router.navigate(["/invoice/" + this.activateroute.snapshot.params["token"]]);
            }
          });
        } else {
          this.loading = false;
          this._flashMessagesService.show("Payment did't process, please contact administration", {
            cssClass: "alert-warning",
            timeout: 5000
          });
        }
      },
      err => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, {
          cssClass: "alert-warning",
          timeout: 5000
        });
      }
    );
  };

  changeMockupButtonText() {
    if (this.projects.status != "Assign" && this.projects.status != "Generate Mockups" && this.projects.status != "Mockups Submitted") {
      this.mockupButtonclass = "btn-large btn-blue";
      let mockupApproveNotes = "";

      if (
        this.projects.projects_data[0] &&
        this.projects.projects_data[0].active_location_arr[0] &&
        this.projects.projects_data[0].active_location_arr[0].emblocation_id
      ) {
        let printloc = this.projects.projects_data[0].active_location_arr[0].emblocation_id;

        if (
          this.projects.projects_data[0].messages &&
          this.projects.projects_data[0].messages[printloc] &&
          this.projects.projects_data[0].messages[printloc].mockup_approval_notes &&
          this.projects.projects_data[0].messages[printloc].mockup_approval_notes.message
        ) {
          mockupApproveNotes = this.projects.projects_data[0].messages[printloc].mockup_approval_notes.message;
        }
      }

      this.mockupButtonText = "Mockups Approved by " + mockupApproveNotes;

    }
    if (this.projects.status && this.projects.status == "Generate Mockups") {
      this.mockupButtonText = "We are working on your mockups"
    }
  }

  getOrderList = function () {
    this.loading = true;
    this.pageLoading = true;
    let invoiceOptions = {
      token: this.activateroute.snapshot.params["token"]
    };

    this.CommonService.apiServicePublicOrder(
      "GET",
      "invoice/" + this.activateroute.snapshot.params["token"]
    ).subscribe(
      (response: any) => {
        this.loading = false;
        this.pageLoading = false;
        if (response.status === true) {
          if (response.data) {
            if (response.data.type === 'Invoice') {
              this.getPaymentHistory(response.data.type, response.data.order_id);
            }
            localStorage.setItem("quote_user_id", response.data.user_id);
            this.showSquareupResponseDialog(response.data);
            let obj = JSON.parse(JSON.stringify(response));
            this.tempProjectData = JSON.parse(JSON.stringify(obj.data.projects_data));
            this.projects = obj.data;
            this.isShippingOptions();
            if (this.projects.turn_off_price_per_peice) {
              this.isturnOffPerPriceView = this.projects.turn_off_price_per_peice == '1' ? true : false;
            }
            if (this.projects.turn_off_impression_cost) {
              this.isTurnOffImpressionCost = this.projects.turn_off_impression_cost == '1' ? true : false;
            }
            this.orderType = obj.data.type;
            this.taskList = this.projects.tasks;
            this.clientData = this.taskList.find(x => x.is_visible_to_client == 1);
            if (this.orderType == "Invoice") {
              this.changeMockupButtonText();
            }
            localStorage.setItem("shopID", this.projects.shop_id);

            if (this.projects.turn_around_times) {
              this.turnAroundName = this.projects.turn_around_times;
            }

            this.isTaxExempt = response.data.is_tax_exempt;
            this.taxRate = response.data.tax_rate;

            if (this.orderType == "Quote") {
              this.is_payment_term = obj.data.is_payment_term;
              this.getPrice();
              this.scheduledDate = response.data.scheduled_date ? response.data.scheduled_date : '';
            }

            if (this.projects.paid_amount) {
              this.balanceAmount = (this.projects.grand_total_price - this.projects.paid_amount);
            }
            else {
              this.balanceAmount = (this.projects.grand_total_price);
            }

            if (response.data.is_connect_qbo) {
              this.isConnectQBO = response.data.is_connect_qbo;
            }
          }
        }
      },
      err => {
        this.loading = false;
        this.pageLoading = false;
        console.log(err);
      }
    );
  }

  showSquareupResponseDialog(data: any) {
    if (localStorage.getItem('isSquareupResponse') && localStorage.getItem('isSquareupResponse') == 'true') {
      localStorage.removeItem('isSquareupResponse');
      if (data.SquareupPayment) {
        if ((data.SquareupPayment.amount) && (data.SquareupPayment.transaction_id) && (data.SquareupPayment.receipt_url)) {
          const dialogRef = this.dialog.open(SquareupResponseComponent, {
            width: "500px",
            disableClose: true,
            data: {
              transactionID: data.SquareupPayment.transaction_id,
              amount: data.SquareupPayment.amount,
              receiptUrl: data.SquareupPayment.receipt_url,
              isPublic:true
            }
          });
          dialogRef.afterClosed().subscribe(result => {
          });
        }
      }
    }
  }

  convertObjectToArray(objList) {

    let addOnInput = Object.keys(objList).map(key => ({ addonid: key, addoncolor: objList[key] }));
    let objectArrayList = [];
    for (let prop in addOnInput) {
      objectArrayList.push(addOnInput[prop]['addoncolor']);
    }
    return objectArrayList;
  }

  totalQuantity = function (rowArr) {
    if (Object.keys(rowArr).length > 0) {
      return rowArr.reduce(function (a, b) {
        return a + b;
      }, 0);
    }
    else {
      return 0;
    }
  }

  isReplyValid(cStatus) {
    return (cStatus == 'Complete' || cStatus == 'Cancel') ? false : true;
  }

  openReplyBox(isOpenComments, printLocs) {
    this.isOpenComments = {}
    this.isOpenComments[printLocs] = !isOpenComments;
    this.currentMessage[printLocs] = {
      invoice: ''
    };
  }

  sendReply = function (pKey, printLocs, msgType) {
    this.loading = true;
    let projectKey = pKey + 1;
    let msgKey = (msgType == 'invoice') ? 'comments' : (msgType == 'revision') ? 'revisions' : 'mockup_approval_notes';
    let messageOptions = {
      id: this.projects.user_id,
      invoice_id: this.projects.order_id,
      project: projectKey,
      location: printLocs,
      message: this.currentMessage[printLocs][msgType]
    }
    if (this.currentMessage[printLocs][msgType]) {
      this.CommonService.apiService(
        "POST",
        "invoice/message",
        messageOptions
      ).subscribe(
        (response: any) => {
          this.loading = false;
          if (response.status === true) {

            if (msgType == 'mockup_approval_notes') {
              this.projects.projects_data[pKey].messages[printLocs][msgKey] = {
                message: this.currentMessage[printLocs][msgType],
                first_name: this.projects.user_first_name,
                last_name: this.projects.user_last_name,
                created_at: new Date(),
                type: 'User'
              };
            }
            else {

              if (this.projects.projects_data[pKey].messages && this.projects.projects_data[pKey].messages[printLocs] && this.projects.projects_data[pKey].messages[printLocs][msgKey]) {
                this.projects.projects_data[pKey].messages[printLocs][msgKey].unshift({
                  message: this.currentMessage[printLocs][msgType],
                  first_name: this.projects.user_first_name,
                  last_name: this.projects.user_last_name,
                  created_at: new Date(),
                  type: 'User'
                });
              }
              else {

                if (this.projects.projects_data[pKey].messages && this.projects.projects_data[pKey].messages[printLocs]) {
                  Object.assign(this.projects.projects_data[pKey].messages[printLocs], {
                    [msgKey]: [{
                      message: this.currentMessage[printLocs][msgType],
                      first_name: this.projects.user_first_name,
                      last_name: this.projects.user_last_name,
                      created_at: new Date(),
                      type: 'User'
                    }]

                  });
                }
                else if (this.projects.projects_data[pKey].messages) {
                  Object.assign(this.projects.projects_data[pKey].messages, {
                    [printLocs]: {
                      [msgKey]: [{
                        message: this.currentMessage[printLocs][msgType],
                        first_name: this.projects.user_first_name,
                        last_name: this.projects.user_last_name,
                        created_at: new Date(),
                        type: 'User'
                      }]
                    }

                  });
                }
                else if (!this.projects.projects_data[pKey].messages) {
                  Object.assign(this.projects.projects_data[pKey], {
                    messages: {
                      [printLocs]: {
                        [msgKey]: [{
                          message: this.currentMessage[printLocs][msgType],
                          first_name: this.projects.user_first_name,
                          last_name: this.projects.user_last_name,
                          created_at: new Date(),
                          type: 'User'
                        }]
                      }
                    }
                  });
                }

              }
            }
            this.currentMessage = {};
            this.isOpenComments = {};

          }
        },
        err => {
          this.loading = false;
          console.log(err);
        }
      );



    }
  }

  getPrice = function () {
    if (!(this.projects.type == 'Invoice' && this.projects.isInvoiceEditable === 0)) {
      this.loading = true;
      let projects = this.tempProjectData;
      let user_id = this.projects.user_id;
      let finalArr = []
      projects.forEach((pvalue, pkey) => {
        let activeLoc = pvalue.active_location_arr;
        let projectTitle = (pvalue.projectTitle) ? pvalue.projectTitle : "";
        let isCheckedProjectTab = (pvalue.isCheckedProjectTab) ? pvalue.isCheckedProjectTab : "";
        let totalPriceCalculation = (pvalue.totalPriceCalculation) ? pvalue.totalPriceCalculation : false;
        if (pvalue.products && pvalue.products.length > 0) {
          pvalue.products.forEach((product, key) => {
            if (finalArr[pkey] && finalArr[pkey].products) {
              Object.assign(finalArr[pkey].products, { [product.product_id]: {} });
              Object.assign(finalArr[pkey].products_matrix, { [product.product_id]: {} });
            }
            else {
              finalArr[pkey] = {
                'products': { [product.product_id]: {} },
                'products_matrix': { [product.product_id]: {} },
                'printPositionSetting': pvalue.printPositionSetting,
                'finishingDetails': (pvalue.finishing_type_id) ? pvalue.finishing_type_id : [],
                'inkDetail': (pvalue.ink_Details && pvalue.ink_Details.ink_type_id) ? pvalue.ink_Details.ink_type_id : null,
                'section_items': pvalue.section_items,
                'isCheckedProjectTab': isCheckedProjectTab,
                'projectTitle': projectTitle,
                'productsMatrixData': pvalue.products,
                'totalPriceCalculation': totalPriceCalculation
              };
            }
            finalArr[pkey].ownGarmentsWeight = pvalue.ownGarmentsWeight;

            // set inkColors under printPositionSetting
            if (activeLoc && activeLoc.length > 0) {
              activeLoc.forEach((lval, lkey) => {

                if (pvalue.inkColors && pvalue.inkColors[lval.emblocation_id]) {
                  let tmpInkColor = (pvalue.inkColors[lval.emblocation_id]) ? pvalue.inkColors[lval.emblocation_id] : [];
                  if (pvalue.printPositionSetting[lval.emblocation_id]) {
                    pvalue.printPositionSetting[lval.emblocation_id]['inkColors'] = tmpInkColor;
                  }
                  else {
                    pvalue.printPositionSetting[lval.emblocation_id] = { ['inkColors']: tmpInkColor };
                  }
                }

                // set printAddonSetting under printPositionSetting
                if (pvalue.printAddonSetting) {
                  if (pvalue.printPositionSetting[lval.emblocation_id]) {
                    pvalue.printPositionSetting[lval.emblocation_id]['printAddonSetting'] = (pvalue.printAddonSetting[lval.emblocation_id]) ? pvalue.printAddonSetting[lval.emblocation_id] : {};
                  }
                }

                // set inkChangeData under printPositionSetting
                if (pvalue.inkChangeData) {
                  if (pvalue.printPositionSetting[lval.emblocation_id]) {

                    if (pvalue.inkChangeData[lval.emblocation_id]) {

                      pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = this.processInkChangeData(pvalue.inkChangeData[lval.emblocation_id]);

                    }
                    else {
                      pvalue.printPositionSetting[lval.emblocation_id]['inkChangeData'] = [];
                    }

                  }
                }
                if (pvalue.artwork) {
                  let artTmp = Object.keys(pvalue.artwork).length;
                  if (pvalue.artwork && artTmp > 0) {
                  }
                }
                finalArr[pkey].printPositionSetting = pvalue.printPositionSetting;
              });
            }
            product.matrix.forEach(function (mval, mkey) {
              if (finalArr[pkey].products[product.product_id]) {
                Object.assign(finalArr[pkey].products[product.product_id], { [mval.color.color_id]: {}, type: product.productDetail.type });
                Object.assign(finalArr[pkey].products_matrix[product.product_id], { [mval.color.color_id]: mval.matrix_id });
              }
              else {
                finalArr[pkey].products[product.product_id] = { [mval.color.color_id]: {}, type: product.productDetail.type };
                finalArr[pkey].products_matrix[product.product_id] = { [mval.color.color_id]: mval.matrix_id };
              }
              mval.quantity.forEach(function (qval, qkey) {

                if (qval && qval > 0) {
                  if (finalArr[pkey].products[product.product_id][mval.color.color_id]) {
                    Object.assign(finalArr[pkey].products[product.product_id][mval.color.color_id], { [mval.size[qkey].size_id]: qval });
                  }
                  else {
                    finalArr[pkey].products[product.product_id][mval.color.color_id] = { [mval.size[qkey].size_id]: qval };
                  }
                }
              });
            });
          });
        }
        else {
          finalArr[pkey] = {
            'section_items': pvalue.section_items
          }
        }
      });

      let otherData = {
        user_id: this.projects.user_id ? this.projects.user_id : '',
        address_id: (this.projects.shipping_address && this.projects.shipping_address.address_id) ? this.projects.shipping_address.address_id : this.projects.address_id ? this.projects.address_id : '',
        turn_around_time: this.projects.turn_around_time_key ? this.projects.turn_around_time_key : 0,
        shipping_method: this.projects.shipping_method_key ? this.projects.shipping_method_key : "local_pickup"
      }
      let quoteOpt = {
        id: this.projects.shop_id,
        projects_data: finalArr,
        user_id: otherData.user_id,
        address_id: otherData.address_id,
        turn_around_time: otherData.turn_around_time,
        shipping_method: otherData.shipping_method,
        one_time_discount_type: this.projects.one_time_discount_type ? this.projects.one_time_discount_type : '',
        one_time_discount: this.projects.one_time_discount ? this.projects.one_time_discount : 0,
        is_tax_exempt: this.isTaxExempt,
        tax_rate: this.taxRate,
      };

      this.CommonService.apiService(
        "POST",
        "v3/order/get_prices",
        quoteOpt
      ).subscribe(
        (response: any) => {
          if (response.status === true) {
            this.loading = false;
            if(this.orderType == 'Quote'){
              this.projects.delivery_date = response.data.delivery_date;
            }
            this.projects.delivery_days = response.data.delivery_days;
            this.projects.discount = response.data.discount;
            this.projects.discount_percentage = response.data.discount_percentage;
            this.projects.grand_total_price = response.data.grand_total_price;
            this.projects.shipping_price = response.data.shipping_price;
            this.projects.tax = response.data.tax;
            this.projects.tax_exempt = response.data.tax_exempt ? response.data.tax_exempt : false;
            this.projects.tax_percentage = response.data.tax_percentage;
            this.projects.total_price = response.data.total_price;
            this.projects.total_printing_price = response.data.total_printing_price;
            this.projects.total_products_price = response.data.total_products_price;
            this.projects.total_quantity = response.data.total_quantity;
            this.projects.total_weight = response.data.total_weight;
            this.projects.turn_around_time_price = response.data.turn_around_time_price;
            this.projects.total_projects = response.data.total_projects;
            this.projects.total_custom_items_price = response.data.total_custom_items_price;
            this.projects.turn_around_time = '0';
            this.projects.paypal_payment_enable = response.data.paypal_payment_enable;
            this.projects.paypal_payment_api_key = response.data.paypal_payment_api_key;
            this.projects.cc_payment_enable = response.data.cc_payment_enable;
            this.projects.cc_payment_api = response.data.cc_payment_api;
            this.projects.one_time_discount = response.data.one_time_discount;
            this.projects.one_time_discount_type = response.data.one_time_discount_type;
            this.projects.one_time_discounted_amt = response.data.one_time_discounted_amt;
            // set  printing price  per project
            for (let i = 0; i < this.projects.projects_data.length; i++) {
              let activeProjectIndex = i;
              this.projects.projects_data[activeProjectIndex].total_printing_price = response.data.projects[activeProjectIndex].total_printing_price;

              this.projects.projects_data[activeProjectIndex].priceMarkupProduct = response.data.projects[activeProjectIndex].priceMarkupProduct;

            }
            if (response.data.addresses.length > 0) {
              this.address = response.data.addresses;
            }
            if (response.data.turn_around_times.length > 0) {
              this.turnAroundTimes = response.data.turn_around_times;
            }
            if (otherData.shipping_method == "local_pickup") {
              this.projects.shipping_method = response.data.shipping_methods.local_pickup;
            }
            this.shipping = [];
            Object.entries(response.data.shipping_methods).forEach(
              ([skey, value]) => {
                this.shipping.push(
                  {
                    key_value: skey,
                    name: value
                  });
              });
            if (this.isShowCheckout)
              this.openCheckOutDialog();

          }
        },
        err => {
          this.loading = false;
          console.log("error msg", err.error.message);
        }
      );
    }
  }

  processInkChangeData(inkData) {
    let tmpArr = [];
    inkData.updData.forEach((val, key) => {
      tmpArr[key] = { 'inkColors': [] };
    });

    Object.values(inkData.colorChange).forEach((val, key) => {
      Object.entries(val).forEach(
        ([pkey, value]) => {
          if (tmpArr[key].inkColors) {
            tmpArr[key].inkColors.push(val[pkey].upd.ink_id);
          }
          else {
            tmpArr[key] = { inkColors: [val[pkey].upd.ink_id] };
          }
        }

      );

    });
    return tmpArr;
  }

  showInkChangeDialog(inkChange, selectedInkColorObj, locs, active_image_loc): void {

    if (inkChange) {
      const dialogRef = this.dialog.open(InvoiceItemComponent, {
        width: "800px",
        disableClose: true,
        data: {
          inkChangeData: inkChange,
          active_artwork_loc: locs,
          selectedInkColorObj: selectedInkColorObj,
          active_image_loc: active_image_loc
        }
      });

      dialogRef.afterClosed().subscribe(result => {

      });
    }
  }

  showCustomNameNumberDialog(products, otherPrintSettings, locs): void {
    const dialogRef = this.dialog.open(InvoiceItemComponent, {
      width: "800px",
      disableClose: true,
      data: {
        productsData: products,
        active_artwork_loc: locs,
        otherPrintSettings: otherPrintSettings
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  showProductDetail(productId, selectedProductColor): void {
    let productPrices = 0;
    let price = 0;
    const dialogRef = this.dialog.open(ProductDetailComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        productId: productId,
        price: price,
        pageType: "Quantity",
        is_public_url: 'Yes',
        selectedProductColor: selectedProductColor
      }
    });
  }

  checkSectionCustomItems = function (pKey, projectsData) {
    if (projectsData.custom_items && projectsData.custom_items.length > 0) {
      this.projects.projects_data[pKey]['section_items'] = [{
        'lable': "Section Title Click to Edit",
        'custom_items': projectsData.custom_items
      }];
    }
    if (projectsData.custom_items) {
      delete this.projects.projects_data[pKey].custom_items;
    }
    if (!this.projects.projects_data[pKey].section_items) {
      this.projects.projects_data[pKey]['section_items'] =
        [
          {
            'lable': "Section Title Click to Edit",
            'custom_items': [
              {
                item: "",
                price: "0",
                quantity: "0",
                description: ""
              }
            ]
          }
        ]
    }
    return this.projects.projects_data[pKey].section_items;
  }

  showShipmentTrackingDialog(shipment): void {
    const dialogRef = this.dialog.open(ShippingInfoComponent, {
      width: "600px",
      disableClose: true,
      data: {
        shipmentData: shipment
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });

  }

  showMakePayment() {
    this.loading = true;
    if (this.orderType == "Invoice") {
      this.isShowCheckout = true;
      if (this.projects.isInvoiceEditable === 0) {
        this.openCheckOutDialog();
      } else {
        this.getPrice();
      }
    }
    else {
      this.isShowCheckout = false;
      this.openCheckOutDialog();
    }
  }

  openCheckOutDialog() {
    const dialogRef = this.dialog.open(CheckOutComponent, {
      width: "600px",
      disableClose: true,
      data: {
        isPublicQuoteCreation: false,
        is_public_url: 'Yes',
        allowPartialPayment: this.projects.allow_partial_payment_public_url,
        user_id: this.projects.user_id,
        amount: this.orderType == 'Quote' ? this.projects.grand_total_price : this.balanceAmount,
        paidAmount: this.projects.paid_amount,
        order_id: this.projects.order_id,
        manageData: { guest_email: '' },
        order_instructions_payment: this.projects.order_instructions_payment,
        order_instruction_title: this.projects.order_instruction_title,
        paypal_payment_enable: this.projects.paypal_payment_enable,
        paypal_payment_api_key: this.projects.paypal_payment_api_key,
        turnAroundTimes: this.turnAroundTimes,
        turn_around_time: this.projects.turn_around_time_key ? this.projects.turn_around_time_key : 0,
        shipping_method: this.projects.shipping_method_key ? this.projects.shipping_method_key : "local_pickup",
        shipping: this.shipping,
        is_payment_term: this.is_payment_term,
        projects: this.projects,
        shippingAddress: this.address,
        turnAroundName: this.turnAroundName,
        cc_payment_enable: this.projects.cc_payment_enable,
        cc_payment_api: this.projects.cc_payment_api,
        orderType: this.orderType,
        isShippingOption: this.isShippingOption,
        isLocalPickupOption: this.isLocalPickupOption,
        cardProcessingFees: this.cardProcessingFees,
        isConnectQBO: this.isConnectQBO,
        scheduledDate: this.scheduledDate,
        is_tax_exempt: this.isTaxExempt,
        tax_rate: this.taxRate,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.getOrderList();
      }
    });
  }

  ShowArtworkDialog(artwork, mockupData, printPosition, artFileInkcolor, pkey, printLoc, mockupFileName, userId): void {

    const dialogRef = this.dialog.open(InvoiceItemComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        item_type: '',
        artworkFiles: artwork,
        mockupDataFiles: mockupData,
        mockupFileName: mockupFileName,
        printLocation: printLoc,
        printPosition: printPosition,
        artFileInkcolor: artFileInkcolor,
        userId: userId,
        artMockupData: { invoiceId: this.projects.order_id, projectKey: pkey, projectStatus: this.projects.status },
        isPublicUrl: 'Yes'
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  onPrint() {
    window.print();
  }

  showMockupMessage(mockupMessageData, imgSrc, locs, finishingDetails, pkey): void {
    const dialogRef = this.dialog.open(InvoiceItemComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        assignStatus: this.projects.status,
        mockupMessageData: mockupMessageData,
        active_artwork_loc: locs.emblocation_id,
        mockup_img: imgSrc,
        finishingDetails: finishingDetails,
        activeMockupData: { invoiceId: this.projects.order_id, projectKey: pkey, printLocs: locs.emblocation_id, locName: locs.name },
        isPublicUrl: 'Yes',
        token: this.activateroute.snapshot.params["token"],
        userId: this.projects.user_id,
        first_name: this.projects.user_first_name,
        last_name: this.projects.user_last_name,

      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/invoice/" + this.activateroute.snapshot.params["token"]]));
      }
    });
  }

  showAllMockupRevision() {
    const dialogRef = this.dialog.open(AllMockupRevisionComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        user_id: this.projects.user_id,
        first_name: this.projects.user_first_name,
        last_name: this.projects.user_last_name,
        assignStatus: this.projects.status,
        projectData: this.projects.projects_data,
        isPublicUrl: 'Yes',
        token: this.activateroute.snapshot.params["token"],
        invoiceId: this.projects.order_id
      }
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  convertToNumber(value) {
    return Number(value);
  }

  calculatePricePerPiece(priceMarkupData, productId, colorId, sizeId, totalPrintingPrice, totalQty, qtyPerSize) {
    let totalPricePerPiece = 0;
    if (priceMarkupData != '' && qtyPerSize > 0) {
      let priceMarkup = (priceMarkupData[productId] && priceMarkupData[productId][colorId] && priceMarkupData[productId][colorId][sizeId] && priceMarkupData[productId][colorId][sizeId].priceMarkup) ? priceMarkupData[productId][colorId][sizeId].priceMarkup : 0;
      let perPiecePrintPrice = totalPrintingPrice > 0 ? totalPrintingPrice / totalQty : 0;
      let perPiecePriceMarkup = priceMarkup > 0 ? priceMarkup / qtyPerSize : priceMarkup;
      let totalPricePerPiece = this.numRoundToPlace((perPiecePriceMarkup + perPiecePrintPrice), 2);
      return totalPricePerPiece;
    }
    else {
      return totalPricePerPiece;
    }
  }

  numRoundToPlace(num, dec) {
    if ((typeof num !== 'number') || (typeof dec !== 'number'))
      return false;

    var num_sign = num >= 0 ? 1 : -1;
    return (Math.round((num * Math.pow(10, dec)) + (num_sign * 0.0001)) / Math.pow(10, dec)).toFixed(dec);
  }

  isShippingOptions = function () {
    const options = [
      'shipping_options',
      'local_pickup_options',
      'cardProcessingFees'
    ];

    this.SettingService.getSetting(options, this.projects.shop_id).subscribe(
      (response: any) => {
        if (response.status === true) {
          if (response.data.shipping_options === '0') {
            this.isShippingOption = false;
          }

          if (response.data.local_pickup_options === '0') {
            this.isLocalPickupOption = false;
          }

          if (response.data.cardProcessingFees) {
            this.cardProcessingFees = JSON.parse(response.data.cardProcessingFees);
          }
        }
      }
    );
  }

  ShowLineItemArtworkDialog(projects, projectKey, sectionKey, customItemKey): void {
    const dialogRef = this.dialog.open(InvoiceItemComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        lineItemArtworkData: { 
          invoiceId: this.projects.order_id,
          projectStatus: this.projects.status,
          projects: projects,
          projectKey: projectKey,
          sectionKey: sectionKey,
          customItemKey: customItemKey,
        },
        userId: projects.user_id,
        orderType: this.orderType,
        isPublicUrl: 'Yes'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  ShowLineItemMockupDialog(projects, projectKey, sectionKey, customItemKey): void {
    const dialogRef = this.dialog.open(InvoiceItemComponent, {
      width: "90%",
      maxWidth: "none",
      disableClose: true,
      data: {
        lineItemMockupData: { 
          invoiceId: this.projects.order_id,
          projectStatus: this.projects.status,
          projects: projects,
          projectKey: projectKey,
          sectionKey: sectionKey,
          customItemKey: customItemKey,
        },
        userId: projects.user_id,
        first_name: this.projects.user_first_name,
        last_name: this.projects.user_last_name,
        orderType: this.orderType,
        assignStatus: this.projects.status,
        isPublicUrl: 'Yes'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/invoice/" + this.activateroute.snapshot.params["token"]]));
      }
    });
  }

  getTaxDisplay(taxExempt: boolean, tax: string | number): string {
    const taxValue = parseFloat(tax as string);
    if (taxExempt && taxValue === 0) {
      return 'Tax Exempt';
    } else {
      return `$${taxValue.toFixed(2)}`;
    }
  }

  getPaymentHistory(orderType, orderId) {
    if (orderType === 'Invoice') {
      this.CommonService.getPaymentHistory({order_id: orderId}).subscribe((response: any) => {
        if (response.status === true) {
          this.paymentHistory = response.data;
        }
      },
        err => {
          this.paymentHistory = [];
        }
      );

      this.getRefundHistory(orderId);

    }
  }

  getRefundHistory(orderId) {
    this.CommonService.getRefundHistory({order_id: orderId}).subscribe((response: any) => {
      if (response.status === true) {
        this.refundHistory = response.data;
      }
    },
      err => {
        this.refundHistory = [];
      }
    );
  }


}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-public-order/public-order/public-order.component.ts